export enum LegalTerms {
	USER_AGREEMENT = 'User Agreement',
	PRIVACY_POLICY = 'Privacy Policy',
	COOKIE_POLICY = 'Cookie Policy',
}

export enum LegalLinks {
	USER_AGREEMENT = '',
	PRIVACY_POLICY = '',
	COOKIE_POLICY = '',
}
